import {registerPlugin} from '@capacitor/core';

export const StorageHelperPlugin = registerPlugin<{
    cleanTmpFolder: () => Promise<void>;
    cleanDocumentScannerFiles: () => Promise<void>;
}>('StorageHelper');
